import React from 'react';
import If from '../operator/if';

export default props => (
  <If condicao={!props.hide}>
    <div className="login-field">
      <span className="login-field-icon" aria-hidden="true">
        <i className={`fa fa-${props.icon}`} />
      </span>
      <input
        {...props.input}
        className="login-field-input"
        placeholder={props.placeholder}
        readOnly={props.readOnly}
        type={props.type}
      />
    </div>
  </If>
);
